import React, {useCallback, useContext, useState} from 'react';
import {Box, Container, TextField, Alert} from "@mui/material";
import {gql, useMutation, useQuery} from "@apollo/client";

import {useNavigate} from "react-router-dom";
import i18n from "../../../i18n";

import {NavigationFooter} from '../../../components/NavigationFooter';

import {NodeTable} from '../../../components/NodeTable';

import {AppContext} from '../../../contexts/AppContext';
import {LeadlistView} from "../leadlist/overview";
import {LoadingPage} from "../../../components/LoadingPage";

const MUTATION = gql`
  mutation createLeadsFromExternalArtistUrls($urls: [String]) {
    createLeadsFromExternalArtistUrls(urls: $urls) {
      upload {
        slug
        leadlists {
          slug
        }
      }
    }
  }
`

const ASSIGN_MUTATION = gql`
    mutation assignLeadlist($slug: String!, $username: String) {
        assignLeadlist(slug: $slug, username: $username) {
            leadlist {
                slug
            }
        }
    }
`

export function CreateLeadPage() {
  const navigate = useNavigate()
  const handleLeadCreated = (lead) => {
    navigate(`/dashboard/queue`)
  }
  return (
    <Container>
      <CreateLeadView onLeadCreated={handleLeadCreated} standalone={true}/>
    </Container>
  )
}

export function CreateLeadView({
  onLeadCreated = (lead) => {
  },
  standalone = false
}) {
  const [leadlist, setLeadlist] = useState(null)
  const [urls, setUrls] = useState([])
  const [loading, setLoading] = useState(false)
  const [spotifyArtistUrls, setSpotifyArtistUrls] = useState([])
  const [invalidSpotifyUrls, setInvalidSpotifyUrls] = useState([])

  const [createLeadsFromExternalArtistUrls, {
    data: submitData,
    loading: submitting,
    error: submitError
  }] = useMutation(MUTATION)

  const [assignLeadlist, {
    data: assignData,
    loading: assigning,
    error: assignError
  }] = useMutation(ASSIGN_MUTATION)

  const {addProcess} = useContext(AppContext)

  const handleSubmit = (event) => {
    event.preventDefault()
    assignLeadlist({
      variables: {
        slug: leadlist.slug
      }
    }).then(({data: {lead}}) => {
      onLeadCreated(lead)
    })
    return false;
  }

  const handleInput = (event) => {
    const html = event.target.innerHTML
    const spotifyArtistRegex = /((https?:\/\/open\.spotify\.com)|(spotify))([\/:])(artist)([\/:])([a-z0-9]+)/gi;
    
    const regex = /((https?:\/\/open\.spotify\.com)|(spotify))([\/:])(artist|user|playlist|track|album)([\/:])([a-z0-9]+)/gi;
    const spotifyUrls = []
    const spotifyArtistUrls = []
    const invalidSpotifyUrls = []

    let paste = (event.clipboardData || window.clipboardData).getData("text/html");
    if (!paste) {
      paste = (event.clipboardData || window.clipboardData).getData("text");
    }
    paste.replace(regex, (url) => {
      if (spotifyUrls.indexOf(url) === -1) {
        spotifyUrls.push(url)
      }
    })

    spotifyUrls.map(url => {
      if (spotifyArtistRegex.test(url)) {
        spotifyArtistUrls.push(url)
      } else {
        invalidSpotifyUrls.push(url)
      }
    })

    if (spotifyArtistUrls.length > 10) {
      alert("Max 10 Spotify URLs at the same time")
      return
    }

    setSpotifyArtistUrls(spotifyArtistUrls)

    setInvalidSpotifyUrls(invalidSpotifyUrls)

    if (spotifyArtistUrls?.length > 0) {
      setLoading(true)
      addProcess(
        createLeadsFromExternalArtistUrls({
          variables: {
            urls: spotifyArtistUrls.slice(0, 5)
          }
        })
      ).then(({data: { createLeadsFromExternalArtistUrls: { upload: { leadlists }}}}) => {
        setLeadlist(leadlists[0])
        setLoading(false)
      })
    }
  }

  const handlePaste = useCallback((event) => { 
    handleInput(event) 
  }, [spotifyArtistUrls, invalidSpotifyUrls])

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Box className="linksGrid">
          <Box>
            {invalidSpotifyUrls?.length > 0 && (
              <Alert
                severity="warning"
              >
                {i18n.t('invalid-spotify-artist-url-has-been-omitted')}
              </Alert>
            )}
            <div contentEditable
              className={"linkboard " + (invalidSpotifyUrls?.length > 0 && 'warning')}
              name={'urls'}
              onPaste={handlePaste}
              placeholder="Paste a list of Spotify URLs (Eg. from Google Sheets) and it will lookup the artists"
              variant="standard"
              label={i18n.t()}
            />
          </Box>
          {loading ? <LoadingPage /> : leadlist ? <LeadlistView displayColumns={['player', 'name', 'monthlyListeners', 'contractValueInEur']} slug={leadlist?.slug} /> : <Box />}
        </Box>
        <NavigationFooter
          finishLabel={"Import leads"}
          saving={assigning}
          finishButtonProps={{
            disabled: spotifyArtistUrls?.length < 1 || loading
          }}
          onFinishClicked={() => {
          }}
        />
      </form>
    </>
  )
}